import React from 'react';
import { Box, Skeleton } from '@mui/material';
import FlexBox from '@/atomic-components/FlexBox';

const DeliveryCardSkeleton = () => {
	return (
		<Box
			sx={{
				padding: '12px',
				background: 'white',
				borderRadius: '14px',
				border: '1px solid #E0E0E0',
			}}
		>
			<FlexBox fullWidth justifyContent='space-between' alignItems='flex-start'>
				<Box sx={{ width: '75%' }}>
					<Box mb='8px'>
						<Skeleton
							variant='text'
							width='30%'
							height={24}
							sx={{ borderRadius: '4px' }}
						/>
					</Box>

					<Skeleton
						variant='text'
						width='100%'
						height={20}
						sx={{ borderRadius: '4px' }}
					/>
				</Box>

				<Skeleton
					variant='rounded'
					width={90}
					height={36}
					sx={{ borderRadius: '24px' }}
				/>
			</FlexBox>
		</Box>
	);
};

export default DeliveryCardSkeleton;
